<template>
  <v-card>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
            :headers="headers"
            :items="languages"
            :loading="isLoading"
            :search="search"
            :rows-per-page-items='[{"text":"All","value":-1}]'
            disable-initial-sort
            class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.id }}</td>
        <td class="text-xs-left">{{ props.item.locale }}</td>
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="justify-center layout px-0">
          <v-icon
                  small
                  class="mr-2"
                  @click="$emit('edit', props.item)"
          >
            edit
          </v-icon>
        </td>
      </template>
      <template slot="no-data">
        <v-alert :value="errorOnLoad" color="error">
          Произошла ошибка при получении данных :(
        </v-alert>
        <div v-if="!errorOnLoad">No data</div>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { FETCH_LANGUAGES } from '../store/action-types'

export default {
  data () {
    return {
      search: '',
      errorOnLoad: null,
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Locale', value: 'locale' },
        { text: 'Name', value: 'name' },
        { text: 'Actions', value: 'id', sortable: false }
      ]
    }
  },
  computed: {
    ...mapState([
      'languages'
    ]),
    ...mapGetters([
      'isLoading'
    ])
  },
  created () {
    this.$store.dispatch(FETCH_LANGUAGES)
  }
}
</script>
